import { render, staticRenderFns } from "./AlertSetup.vue?vue&type=template&id=46303004&"
import script from "./AlertSetup.vue?vue&type=script&lang=js&"
export * from "./AlertSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports